import React, { Component } from "react"
import { Redirect } from "react-router-dom"
import * as path from "../../constants/Paths"
import config from "react-global-configuration"
import Spinner from "../spinner"
import { Forms } from "../../../styleguide/js/components/forms"

class AmendSearch extends Component {
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()

    this.state = {
      ajaxSpinnerActive: this.props.ajaxSpinnerActive,
    }
  }
  componentDidMount() {
    new Forms({ el: this.containerRef.current })
  }
  getQueryString = () => {
    const { ammendmentEmail, ammendmentReference } = this.props
    return `?email=${ammendmentEmail}&reference=${ammendmentReference}`
  }

  handleFindClick = () => {
    this.setState({ ajaxSpinnerActive: true })
    this.props.findBooking(this.props.ammendmentEmail, this.props.ammendmentReference)
    this.setState({ ajaxSpinnerActive: false })
  }

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      document.querySelector(".button--large").focus()
      setTimeout(() => this.handleFindClick(), 1)
    }
  }

  render() {
    const textKeys = config.get("textKeys.amendment.search") || {}

    if (this.props.manageBookingResult) {
      return <Redirect to={`${path.AMMEND_SHOW_BOOKING()}${this.getQueryString()}`} />
    }

    return (
      <section className="deck deck--extra-padding-top deck--excessive-padding-bottom" ref={this.containerRef}>
        <Spinner isActive={this.props.ajaxSpinnerActive} isTransparent={this.props.ajaxSpinnerTransparent} />
        <div className="parking-booking-locator">
          <div className="w--normal">
            <div className="form">
              <h3 className="headline-md headline--extra-margin-bottom"> {textKeys.header || "Ændre booking"} </h3>
              <div className="form__section form__section--light form__section--no-border form__section--fat">
                <div className="form__section__inner">
                  <div className="form__field form__field--text ">
                    <span className="form__valid" />
                    <input
                      className="form__item "
                      tabIndex="1"
                      type="email"
                      name="email"
                      onBlur={this.props.updateAmmendmentEmailValue}
                      defaultValue={this.props.ammendmentEmail}
                      onKeyPress={(e) => this.handleKeyPress(e)}
                    />
                    <label htmlFor="" className="form__label">
                      <span className="form__label__text">
                        {textKeys.email || "E-mail"} &nbsp;&nbsp; <strong>&nbsp;</strong>
                      </span>
                    </label>
                    <span className="form__notice ">{textKeys.emailDescription || "Den e-mail du brugte, da du bookede din p-plads"}</span>
                  </div>
                </div>
                <div className="form__section__inner">
                  <div className="form__field form__field--text ">
                    <span className="form__valid" />
                    <input
                      className="form__item "
                      tabIndex="2"
                      type="text"
                      name="bookingnumber"
                      onBlur={this.props.updateAmmendmentReferenceValue}
                      defaultValue={this.props.ammendmentReference}
                      onKeyPress={(e) => this.handleKeyPress(e)}
                    />
                    <label htmlFor="" className="form__label">
                      <span className="form__label__text">
                        {" "}
                        {textKeys.bookingnr || "Reservationsnummer."} &nbsp;&nbsp;<strong>&nbsp;</strong>
                      </span>
                    </label>
                    <span className="form__notice ">
                      {textKeys.bookingNumberDescription || "Du finder reservationsnummer i din ordrebekræftelse"}
                    </span>
                  </div>
                </div>

                {/* <Link to={`${path.AMMEND_SHOW_BOOKING()}${this.getQueryString()}`} className="button button--large button--general d-flex rm-this-class rm-this-class-hide-default"
                    onClick={this.handleFindClick}
                  >         */}
              </div>
              <div className="infoForgotReservation">
                <span className="left">{textKeys.forgotBookingNumberCallout || "Glemt dit reservationsnummer?"}</span>
                <span className="right">
                  <button className="button-link--smalltext" onClick={() => this.props.amendForgotReferenceModalToogle()}>
                    {" "}
                    {textKeys.forgotBookingLink || "Få gensendt din ordrebekræftigelse"}{" "}
                  </button>
                </span>
              </div>
              <div className="centerbutton">
                <button
                  className="button button--large button--general d-flex rm-this-class rm-this-class-hide-default button--mobile-large text-small-wide"
                  onClick={this.handleFindClick}
                >
                  <span className="icon">
                    <svg className="svg-icon svg-icon--planeduo">
                      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-planeduo">
                        &nbsp;
                      </use>
                    </svg>
                  </span>
                  <span className="text"> {textKeys.button || "Vis min reservation"} </span>
                </button>
              </div>

              {/* {this.props.findBookingError?<p>{"Kombinationen af mail og bookingkode kunne ikke findes"}</p>:null} */}
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default AmendSearch
